/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from 'classnames'
import type { FC } from 'react'
import React, { useCallback, useRef, useState } from 'react'

import { useTableContext } from './table-context'
import type { TableCellProps } from './types'
import { BoxPrivate } from '../_primitives/box/box'

const TableCell: FC<TableCellProps> = props => {
  const localRef = useRef<HTMLElement>(null)

  const { variant = 'cell', className, title, children, ...rest } = props
  const { variant: tableVariant } = useTableContext()

  // Define state and function to update the value
  const [showTitle, setShowTitle] = useState(false)

  const handleOnMouseOver = useCallback(() => {
    const compare =
      !!localRef.current &&
      localRef.current.scrollWidth > localRef.current.clientWidth
    setShowTitle(compare)
  }, [localRef])

  // eslint-disable-next-line no-console
  // console.log('rendering tables.cell')
  return (
    <BoxPrivate
      as="td"
      __themeKey="tables"
      className={classNames('csg-tui-td', className)}
      variant={tableVariant ? `${tableVariant}.cell` : variant}
      ref={localRef}
      title={showTitle ? title ?? '' : ''}
      onMouseOver={handleOnMouseOver}
      {...rest}
    >
      {children}
    </BoxPrivate>
  )
}

export default TableCell
